import type { Dispatch, SetStateAction } from "react";
import { Dropdown } from "@/react/components/shared/uikit/Dropdown";
import { ContentFilterButton } from "./ContentFilterButton";

interface ContentFilterDropdownProps<T extends string> {
  options: { label: string; value: T }[];
  selectedTemplateType: T;
  setSelectedTemplateType: Dispatch<SetStateAction<T>>;
  translationKey: string;
}

export const ContentFilterDropdown = <T extends string>({
  selectedTemplateType,
  setSelectedTemplateType,
  options,
  translationKey,
}: ContentFilterDropdownProps<T>) => {
  const handleOnChange = (value: string) => {
    setSelectedTemplateType(value as T);
  };

  return (
    <Dropdown
      className="!mt-2 w-fit"
      direction="bottom-start"
      menuButtonEl="div"
      menuWrapperClassName="!mt-0"
      transitionWrapperClassName="z-20"
      onChange={handleOnChange}
      activeOptionValue={selectedTemplateType}
      button={
        <ContentFilterButton
          selectedTemplateType={selectedTemplateType}
          translationKey={translationKey}
        />
      }
      options={options}
    />
  );
};
